import { Flex, Form, InputText, Text } from '@cellula/react';
import { withTranslation } from '../../with_translation';
import { tokens } from '@cellula/react-theme-patient';
import { useResolve } from '@visiba/instantiation';
import { KioskSessionFlow, SessionController } from '../../session.controller';
import { useNavigate } from 'react-router-dom';

interface Props {
	flow: KioskSessionFlow;
}

export function StartSession({ flow = KioskSessionFlow.Vcs }: Props): JSX.Element {
	const controller = useResolve(SessionController);
	const navigate = useNavigate();

	return (
		<Form.Root
			options={{
				mode: 'onChange',
			}}
			onSubmit={async (value) => {
				await controller.submit(value as { name: string }, flow);
				if (flow === KioskSessionFlow.Vcs) {
					navigate('./session');
				} else {
					navigate('../session');
				}
			}}
		>
			<Flex direction='column' justify='space-between' style={{ height: '100%' }}>
				<Flex gap={tokens.spacing.x2}>
					<Text.h1 variant='headingMedium'>{withTranslation('start-session.title')}</Text.h1>
					<Text.p variant='bodyRegular'>{withTranslation(`start-session.description-flow-${flow}`)}</Text.p>
					<InputText
						label={withTranslation('start-session.input-name')}
						type='text'
						name='name'
						options={{
							required: {
								message: withTranslation('start-session.input-name-invalid'),
								value: true,
							},
						}}
					/>
				</Flex>
				<Flex gap={tokens.spacing.x2}>
					<Form.Error />
					<Form.SubmitButton type='submit' variant='primary' size='large'>
						{withTranslation('start-session.button-next')}
					</Form.SubmitButton>
				</Flex>
			</Flex>
		</Form.Root>
	);
}
